module.exports = __webpack_public_path__ + "img/user_friend_step1.b4db8925.svg";